// extracted by mini-css-extract-plugin
export var hamburger = "styles-module--hamburger--sQOhj";
export var activeBurger = "styles-module--activeBurger--Jd8tt";
export var backAndForthRight = "styles-module--backAndForthRight--GLlQk";
export var wobbleRightAndLeft = "styles-module--wobbleRightAndLeft--qBF9v";
export var animateBg = "styles-module--animateBg--LH1hp";